const Form1099NecHelpData = [
  {
    box: 'a',
    title: "Payer's name, street address, city or town, state or province, country, zip or foreign postal code, and telephone number",
    keywords: [
      'Payer',
      'Payer\'s',
      'Name',
      'Street Address',
      'City',
      'Town',
      'State',
      'Province',
      'Country',
      'Zip',
      'Foreign',
      'Postal',
      'Code',
      'Telephone',
      'Phone',
    ],
    details: ['As the payer, enter your business address details.'],
  },
  {
    box: 'b',
    title: "Payer's TIN, also known as federal identification number",
    keywords: [
      'Payer',
      'Payer\'s',
      'Federal',
      'Identification',
      'Number',
    ],
    details: ['Enter your federal identification number. You can choose between an EIN or a SSN. If you are the sole proprietor, usually you will enter the SSN which is 9 digits, written ### - ## - ####. Your IRS-assigned EIN is nine digits, written ## - #######.'],
  },
  {
    box: 'c',
    title: "Recipient's TIN, also known as identification number",
    keywords: [
      'Recipient',
      'Recipient\'s',
      'Identification',
      'Number',
    ],
    details: ["Enter the recipient's federal identification number. You can choose between an EIN or a SSN. The SSN is 9 digits, written ### - ## - ####. The IRS-assigned EIN is nine digits, written ## - #######."],
  },
  {
    box: 'd',
    title: "Recipient's name, street address, city or town, state or province, country, zip or foreign postal code, and telephone number",
    keywords: [
      'Recipient',
      'Recipient\'s',
      'Name',
      'Payee',
      'Street',
      'Address',
      'Number',
      'City',
      'Town',
      'State',
      'Province',
      'Country',
      'Zip',
      'Foreign',
      'Postal',
      'Code',
    ],
    details: ["Enter the recipient's name and address as it appears on the recipient's Form W-9."],
  },
  {
    box: 'e',
    title: 'Account number (see instructions)',
    keywords: [
      'Account',
      'Number',
      'See',
      'Instruction',
      'Instructions',
    ],
    details: ['If you have more than one account for a recipient and are filing multiple 1099-NECs for a recipient, include an account number.'],
  },
  {
    box: 'f',
    title: '2nd TIN not.',
    keywords: [
      '2nd',
      'Tin',
      'Not',
    ],
    details: ['Check this box if the IRS has notified you twice in the last 3 calendar years that your recipient has given you an incorrect TIN. The IRS will not send further notices regarding this recipient if you checked this box.'],
  },
  {
    box: '1',
    title: 'Nonemployee Compensation',
    keywords: [
      '1',
      'box 1',
      '600',
      'Nonemployee',
      'Nonemployees',
    ],
    details: ['Enter amounts of $600+ made to nonemployees. However, do not use the 1099-NEC to report gross proceeds to an attorney; use the 1099-MISC instead. Additionally, do not use the 1099-NEC to report payments of rent to real estate agents or property managers; use the 1099-MISC instead. Lastly, do not use the 1099-NEC to report cash payments for the purchase of fish for resale purposes; use the 1099-MISC instead.'],
  },
  {
    box: '2',
    title: 'Payer Made Direct Sales of $5,000 or More',
    keywords: [
      '2',
      'box 2',
      'Payer',
      'Made',
      'Direct',
      'Sales',
      'Sale',
      '5000',
      'Consumer',
      'Products ',
      'More',
      'Recipient',
      'Buyer',
      'Buy',
      'Sell',
      'Buy-Sell',
      'Deposit',
      'Commission',
      'Deposit-Commission',
    ],
    details: ['Check this box if you made direct sales of $5000+ of consumer products to a recipient on a buy-sell, deposit-commission, or other commission basis anywhere other than a permanent retail establishment.'],
  },
  {
    box: '4',
    title: 'Federal Income Tax Withheld',
    keywords: [
      '4',
      'box 4',
      'Federal',
      'Income',
      'Tax',
      'Withheld',
    ],
    details: ['Enter any federal income tax withheld.'],
  },
  {
    box: '5',
    title: 'State Tax Withheld',
    keywords: [
      '5',
      'box 5',
      'State',
      'Tax',
      'Withheld',
    ],
    details: ['Enter withheld state income tax for up to two states.'],
  },
  {
    box: '6',
    title: "State/Payer's State no.",
    keywords: [
      '6',
      'box 6',
      'State',
      'Payer',
      'Payer\'s',
      'State',
      'No',
      'Number',
    ],
    details: ['Enter the abbreviated name of the state and your state identification number assigned by the state.'],
  },
  {
    box: '7',
    title: 'State Income',
    keywords: [
      '7',
      'box 7',
      'State',
      'Income',
    ],
    details: ['Enter the amount of earned income in the state.'],
  },
];

export default Form1099NecHelpData;



// WEBPACK FOOTER //
// ./src-react/VisualStatic/HelpData/Form1099NecHelpData.js